'use strict';

import KeepWidth from './keep-width';
import InputMoney from './input-money';
import Focus from './focus';
import FocusFactory from './focus-factory';
import AutoFocus from './auto-focus';
import DeletedColor from './deleted-color';
import ApprovedColor from './approved-color';
import DebtColor from './debt-color';
import InputCuit from './input-cuit.js';
import CashboxLabel from './cashbox-label';
import VehicleLabel from './vehicle';
import ClientLabel from './client-label';
import angular from 'angular';
import DueDateColor from './due-date-color';
import RowTableSeparator from './table-separator';
import AssignationColorDirective from './assignation-color';
import {
  CronologyTypeDirective,
  CronologyDescriptionDirective
} from './cronology';

let directivesModule = angular
  .module('app.directives', [])
  .directive('keepWidth', KeepWidth)
  .directive('inputMoney', InputMoney)
  .directive('focusMe', Focus)
  .directive('autoFocus', AutoFocus)
  .directive('deletedColor', DeletedColor)
  .directive('approvedColor', ApprovedColor)
  .directive('debtColor', DebtColor)
  .directive('inputCuit', InputCuit)
  .directive('cashboxLabel', CashboxLabel)
  .directive('vehicleLabel', VehicleLabel)
  .directive('clientLabel', ClientLabel)
  .directive('dueDateColor', DueDateColor)
  .directive('rowTableSeparator', RowTableSeparator)
  .directive('cronologyType', CronologyTypeDirective)
  .directive('cronologyDescription', CronologyDescriptionDirective)
  .directive('assignationColor', AssignationColorDirective)
  .factory('focus', FocusFactory).name;

export default directivesModule;
